<script>
import CardList from '@/views/CardList'
import Button from '@/components/Button'
import ImageEnlarger from '@/components/ImageEnlarger'
import ReportsServices from '@/services/reports'
import EnvironmentUtils from '@/utils/environmentUtils'
import ArrayUtils from '@/utils/arrayUtils'
import GeolocationUtils from '@/utils/geolocationUtils'
import StringUtils from '@/utils/stringUtils'
import DateUtils from '@/utils/dateUtils'
import PDFUtils from '@/utils/PDFUtils'
import FileUtils from '@/utils/fileUtils'

export default
{
    name: 'reports-management',

    created ()
    {
        ReportsServices.fetchReportTagsDefinition(EnvironmentUtils.cityId, this.$store.state.user.token).then(async tags =>
        {
            await this.$store.commit('reports/setTags', tags)

            const reports = await ReportsServices.fetchReports(EnvironmentUtils.cityId, this.$store.state.user.token)
            await this.$store.commit('reports/updateReportsList', reports)
            
            if (this.$refs.cardList) this.$refs.cardList.selectMenuItemFromCurrentPath()
        })
    },

    render () 
    {
        return (
            <div id='reports-management-view'>
                <card-list ref='cardList' card-object-name='signalement' cards={this.reports} tags={this.tags}
                    on-cards-tags-changed={this.onCardsTagsChanged} on-tags-modified={this.onTagsModified}
                    tags-validator={this.tagsValidator} card-content-creator={this.createCardCollapsibleContent} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    computed:
    {
        reports ()
        {
            return this.$store.state.reports.reportsList.map(o => ({ ...o, title: `Signalement n°${o.id} : ${o.reason}` }))
        },

        tags ()
        {
            return this.$store.state.reports.tags
        }
    },

    methods:
    {
        createCardCollapsibleContent (card)
        {
            const geolocation = StringUtils.isEmptyString(card.geolocation) ? undefined
                : GeolocationUtils.stringToCoords(card.geolocation)

            return <div>
                <div class='section'>
                    <image-enlarger class='card-picture' v-show={!StringUtils.isEmptyString(card.pictureUrl)}
                        src={card.pictureUrl} />
                </div>
                <div class='section'>
                    <div v-show={!card.isAnonymous}>
                        <p class='title'>Envoyé par</p>
                        <p><strong>Prénom: </strong><div class='markable'>{card.senderFirstName}</div></p>
                        <p><strong>Nom: </strong><div class='markable'>{card.senderLastName}</div></p>
                        <p>
                            <strong>Mél: </strong>
                            <a href={`mailto:${card.senderMail}`} target='_blank' class='markable'>{card.senderMail}</a>
                        </p>
                    </div>
                    <p v-show={card.isAnonymous}>L'envoyeur a préféré rester anonyme</p>
                    <p class='date'>Rapporté le {DateUtils.dateToString(card.date, 'iso', 'fr')}</p>
                </div>
                <div class='section action-buttons'>
                    {
                        geolocation && (
                            <Button outlined={true} type='light'
                                text={`Géolocalisation (~${Math.round(geolocation.accuracy)}m)`} 
                                on-click={() => window.open(GeolocationUtils.generateGoogleMapLinkFromCoords(geolocation), '_system')} />
                        )
                    }
                    <Button outlined={true} type='light' text='Télécharger le PDF'
                        on-click={(event, button) => this.downloadPDFClicked(button, card)} />
                    <Button v-show={!card.tags.includes('resolved')} type='primary' text='Marquer comme résolu'
                        on-click={(e, button) => this.setReportAsResolvedClicked(e, button, card)} />
                </div>
            </div>
        },

        async downloadPDFClicked (button, cardData)
        {
            button.showSpinner = true
            const pdf = await PDFUtils.generateReportPDFAsync(cardData)
            pdf.getBlob(async blob =>
            {
                await FileUtils.writeFileToDownloadsAsync(pdf.docDefinition.info.title + '.pdf', blob)
                button.showSpinner = false
            })
        },

        async setReportAsResolvedClicked (event, button, report)
        {
            button.showSpinner = true

            ArrayUtils.pushIfDontExist(report.tags, 'resolved')
            ArrayUtils.removeByValue(report.tags, 'pending')
            this.onCardsTagsChanged([report])

            button.showSpinner = false
        },

        /**
         * @param {Array<object>} cards
         */
        async onCardsTagsChanged (cards)
        {
            const changeData = cards.map(c => ({ id: c.id, tags: c.tags }))
            const updated = await ReportsServices.patchReports(EnvironmentUtils.cityId, this.$store.state.user.token, changeData)
            await this.$store.commit('reports/updateReportsList', updated)
        },

        async onTagsModified (tags)
        {
            const updated = await ReportsServices.setReportTagsDefinition(EnvironmentUtils.cityId, this.$store.state.user.token, tags)
            await this.$store.commit('reports/setTags', updated)
        },

        tagsValidator (set, tags)
        {
            if (set == 'resolved') tags.pending = !tags[set]
            if (set == 'pending') tags.resolved = !tags[set]

        }
    },

    components:
    {
        CardList,
        Button,
        ImageEnlarger
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#reports-management-view
{
    
}
</style>



// WEBPACK FOOTER //
// src/views/ReportsManagement.vue